import {
  GET_SESSION_TICKET_FAIL,
  GET_SESSION_TICKETS_SUCCESS,
  GET_SESSION_TICKET_DETAIL_FAIL,
  GET_SESSION_TICKET_DETAIL_SUCCESS,
  ADD_SESSION_TICKET_SUCCESS,
  ADD_SESSION_TICKET_FAIL,
  UPDATE_SESSION_TICKET_SUCCESS,
  UPDATE_SESSION_TICKET_FAIL,
  CLEAR_MESSAGE,
  DELETE_SESSION_TICKET_SUCCESS,
  DELETE_SESSION_TICKET_FAIL,
  GET_EXPORT_SESSION_TICKETS,
  GET_EXPORT_SESSION_TICKETS_SUCCESS,
  GET_EXPORTED_SESSION_TICKETS_FAIL,
  RESET_EXPORT_DATA,
  MANUAL_LIFTUP_BARRIER_SUCCESS,
  MANUAL_LIFTUP_BARRIER_FAIL,
  GET_SESSION_TICKETS,
} from "./actionTypes"

const INIT_STATE = {
  sessionTicketList: [],
  sessionTicketDetails: {},
  error: {},
  message: "",
  pagination: {},
  search: "",
  file: "",
  isLoading: false,
}

const sessionTickets = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SESSION_TICKETS:
      return {
        ...state,
        isLoading: true,
      }
    case GET_SESSION_TICKETS_SUCCESS:
      return {
        ...state,
        sessionTicketList: action.payload?.data,
        pagination: action.payload?.pagination || {},
        isLoading: false,
      }

    case GET_SESSION_TICKET_FAIL:
      return {
        ...state,
        error: action.payload,
        sessionTicketList: [],
      }
    case ADD_SESSION_TICKET_SUCCESS:
      let sessions = [...state.sessionTicketList]
      sessions.unshift(action?.payload?.data)
      return {
        ...state,
        sessionTicketList: sessions,
        message: action?.payload?.message || "",
      }

    case ADD_SESSION_TICKET_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SESSION_TICKET_DETAIL_SUCCESS:
      return {
        ...state,
        sessionTicketDetails: action.payload,
      }

    case UPDATE_SESSION_TICKET_SUCCESS:
      return {
        ...state,
        message: "Successfully user updated!",
        sessionTicketList: (state?.sessionTicketList || []).map(user => {
          return user._id.toString() === action.payload?.data._id.toString()
            ? { user, ...action.payload?.data }
            : user
        }),
      }

    case UPDATE_SESSION_TICKET_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SESSION_TICKET_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_SESSION_TICKET_SUCCESS:
      let list = state?.sessionTicketList || []
      const findIndex = list.findIndex(
        user => user._id.toString() === action.payload._id.toString()
      )
      if (findIndex > -1 && list.length > 0) {
        list[findIndex].status = "Removed"
      }
      return {
        ...state,
        message: "Session ticket removed successfully!",
        sessionTicketList: list,
      }

    case DELETE_SESSION_TICKET_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CLEAR_MESSAGE:
      return {
        ...state,
        error: {},
        message: "",
      }

    case GET_EXPORT_SESSION_TICKETS: 
    return {
      ...state,
      isLoading: true,
    }
    case GET_EXPORT_SESSION_TICKETS_SUCCESS:
      return {
        ...state,
        message: action.payload?.message,
        file: action.payload?.file,
        error: {},
        isLoading:false,
      }

    case GET_EXPORTED_SESSION_TICKETS_FAIL:
      return {
        ...state,
        file: "",
        error: action.payload?.message || "Error occurred in export file.",
        isLoading:false,
      }

    case RESET_EXPORT_DATA:
      return {
        ...state,
        error: {},
        message: "",
        file: "",
      }
    case MANUAL_LIFTUP_BARRIER_SUCCESS:
      return {
        ...state,
        message: "Manually overrite successfully done!",
        error: {},
      }
    case MANUAL_LIFTUP_BARRIER_FAIL:
      return {
        ...state,
        message: "",
        error: action.payload,
      }
    default:
      return state
  }
}

export default sessionTickets
